import React, { Component } from "react";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import ReadOnly from "../common/ReadOnly";
import withPageStatus from "../common/wrappers/withPageStatus";
import PhoneNumberInput from "../common/PhoneNumberInput";
import PhoneText from "../../assets/PhoneText";
import { track } from "../../api/heap";
import isMobile from "../../utilities/isMobile";
import { connect } from "react-redux";
import * as actions from "../../state/actions/onboarding";
import { Title } from "../common";
import { phone } from 'phone';

class VerifyPhone extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      sending: false,
    };
  }

  // TODO: This component is the first in the steps after an email confirmation,
  // meaning this is where the bulk of the application will be. We want to prevent
  // reloading if possible, but should make sure to
  // ==[ remove the function after we're done ]==, eg, when we get sent to the dashboard
  componentDidMount() {
    // if (!window.onbeforeunload) {
    //   window.onbeforeunload = () => {
    //     return "Refreshing this page will cause you to lose your application progress. Continue?";
    //   };
    // }
    if (window.onbeforeunload) {
      window.onbeforeunload = null;
    }

    if (
      !this.props.noPropsCheck &&
      (!this.props.user || !this.props.user.email.length)
    ) {
      this.timeout = setTimeout(() => {
        this.timeout = null;
        this.props.startOver();
      }, 1000);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.phoneVerificationSent && nextProps.phoneVerificationSent) {
      // If the user goes "back" to this page, this page will
      // automatically send them "forward" to the verify code step,
      // since the verification has already been sent.
      // We allow a re-send through the UI only.
      this.setState({ sending: false });
      // if the user has completed this step already, keypresses
      // can generate new props and they will be moved to the next
      // step on a keypress, which is unintuitive.

      // This is necessary to move to the verifyCode page
      if (this.state.transitioning) return;
      this.setState({ transitioning: true });
      this.props.nextStep();

      // this.setState({ showSent: true });
    }
    if (nextProps.smsSendError) {
      this.setState({ sending: false });
    }
  }

  componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  sendCode = () => {
    track("ONBOARDING_PHONE_VERIFICATION_STEP_CLICKED_SEND_CODE");
    if (this.props.pageComplete) {
      return this.props.nextStep(null, null, 2);
    }
    if (!this.isPhoneNumberValid()) {
      return;
    }
    this.setState({ error: null, sending: true });
    const { email, phoneNumber } = this.props.user;
    this.props.updateUserDatabase(email, { phoneNumber });
    this.props.verificationSmsSend(
      this.props.user.phoneNumber,
      this.props.user.email
    );
  };

  isPhoneNumberValid = (number = this.props.user.phoneNumber) => {
    const validatedPhone = phone(number, {country: "USA"}); // TODO: Support non-US numbers
    if (validatedPhone.isValid) {
      this.props.updateUser({
        phoneNumber: validatedPhone.phoneNumber,
        countryCode: validatedPhone.countryIso3 // currently unused
      });
      track("ONBOARDING_PHONE_VERIFICATION_STEP_VALID_NUMBER");
      this.setState({ error: null });
      return true;
    } else {
      track("ONBOARDING_ERROR_PHONE_VERIFICATION_STEP", {
        message: "not_us_phone_number"
      });
      this.setState({ error: "Valid US phone number required" });
      return false;
    }
  };

  render() {
    const { sendCode } = this;
    const { error, sending, showSent } = this.state;
    const {
      smsSendError,
      pageComplete,
      user: { phoneNumber, email }
    } = this.props;

    const sanitizedPhoneNumber =
      phoneNumber && phoneNumber.length
        ? phoneNumber.slice(
          phoneNumber.indexOf("+1") > -1 ? 2 : 0,
          phoneNumber.length
        )
        : phoneNumber;

    if (
      !this.props.noPropsCheck &&
      (!this.props.user || !this.props.user.email.length)
    ) {
      return (
        <div className="fixed-centered">
          <p>Well, you're not supposed to be here :/</p>
          <p>Sending you back to a safe place...</p>
        </div>
      );
    }

    const mobile = isMobile();

    return (
      <>
        <div className="outerStack-mobile sm:outerStack">
          <div className="innerStack">
            <Title
              text={
                showSent
                  ? `${mobile ? "We sent you a text" : "Check your phone"}`
                  : "Verify your phone number"
              }
              disabled={pageComplete}
              disabledText={"Your phone number has been verified."}
            />
            {/* TODO: Formatting is funny on smaller screen widths */}
            {!showSent && (
              <ReadOnly readOnly={pageComplete}>
                <div className="mt-6">
                  <PhoneNumberInput
                    fontSize={mobile ? 2.2 : 3}
                    onChange={(formattedInputValue, object) => {
                      // New PhoneNumberInput returns an object with more info. Use that
                      // for now instead of raw input value
                      if (object) {
                        const n = object.nationalNumber || null;
                        if (n.length <= 10) {
                          this.props.updateUser({ phoneNumber: n });
                        }
                        if (n.length === 10) {
                          // Careful with timing. Sometimes our redux state takes a split second
                          // to update. That's why we pass in this value here right away!
                          this.isPhoneNumberValid(n);
                        }
                      } else {
                        this.props.updateUser({ phoneNumber: null });
                      }
                    }}
                    onEnter={value => {
                      console.log("User pressed enter with value", value);
                      this.sendCode();
                    }}
                    value={sanitizedPhoneNumber}
                    autofocus
                    disabled={pageComplete}
                  />
                </div>
              </ReadOnly>
            )}
            <div>
              {showSent && (
                <div>
                  {/*<i
                      className="fas fa-mobile-alt"
                      style={{ fontSize: 148 }}
                    />*/}
                  <PhoneText
                    style={{ height: 148, width: 148 }}
                    className="m-auto pl-10"
                  />
                  <div className="font-light mt-8 px-8 text-xl">
                    {mobile ? (
                      <>
                        <b className="font-bold">Open the link</b>
                        <br /> to continue your application
                      </>
                    ) : (
                      <>
                        <b className="font-bold">Open the link sent via text</b> to
                        continue your application
                      </>
                    )}
                  </div>
                </div>
              )}
              {error && (
                <div className="text-red-400 font-open-sans text-sm px-3 mt-3">
                  {" "}
                  <i className="far fa-solid fa-triangle-exclamation mr-1"></i>
                  {error}
                </div>
              )}
              {smsSendError && (
                <div className="text-red-400 font-open-sans text-sm px-3 mt-3">
                  {" "}
                  <i className="far fa-solid fa-triangle-exclamation mr-1"></i>
                  {smsSendError}
                </div>
              )}
              {!showSent && (
                <button className="continueButton cursor-pointer" disabled={sending} style={{ backgroundColor: sending ? "gray" : "#26E3BA" }}
                  onClick={sendCode}> {pageComplete ? "Continue" : sending ?
                    <i className="fas fa-solid fa-circle-notch fa-spin m-auto text-2xl" /> : 'Send Code'} </button>
              )}
            </div>
            {!showSent && (
              <div className="textContainer">
                Did you know? Verifying your phone number helps stop fraud
              </div>
            )}
          </div>
        </div>
      </>
    );
  }
}

export default compose(
  connect(
    state => ({
      user: state.register.user,
      step: state.register.verifyPhone,
      phoneVerificationSent: state.register.phoneVerificationSent,
      smsSendError: state.register.smsSendError
    }),
    actions
  ),
  withPageStatus("verifyPhone"),
  withRouter
)(VerifyPhone);
